var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"go_home",style:({
        top:(_vm.top + "px"),
        left:(_vm.left + "px"),
    }),on:{"click":_vm.goHome,"touchmove":function($event){$event.preventDefault();return _vm.move($event)}}},[_c('i',{staticClass:"iconfont icon-fanhui"})])}
var staticRenderFns = []

export { render, staticRenderFns }